import clsx from "clsx";
import { forwardRef } from "react";
import { Icon, IconClientSpanProps } from "@repo/ui/icon";
import classes from "./spinner.module.css";

export const SpinnerIcon = forwardRef<HTMLSpanElement, IconClientSpanProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <span className={clsx(classes.root, className)} {...props} ref={ref} />
      </Icon>
    );
  },
);

SpinnerIcon.displayName = "SpinnerIcon";
